import React from "react";
import { connect } from "react-redux";

import { setActivity } from "../../widgets/DashboardComponents/V3/ActivityLogWidget/actions";

import {
    Typography,
    Button,
    TextField,
    List,
    ListItem,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from "@material-ui/core";

import {
    selectVehicles,
    getRequesting,
    canUpdate,
    canCreate,
    canDelete,
    selectAreas,
    selectDepartments,
    selectProfile,
    selectCategories,
    selectCategoryTitles,
    selectAllVehicleTypes,
    selectVehicleType,
    selectTemplates,
    getUserProfile
} from "./selectors";
import {
    getVehicles,
    setVehicle,
    removeVehicle,
    getAreas,
    getDepartments,
    uploadFile,
    uploadMultiImages,
    getCategories,
    submitNewCategory,
    setFilterVehicleType,
    getTemplates
} from "./actions";
import { StyledCard, StyledContent, StyledHeader } from "../../styles";
import {
    AddEditModal,
    VehicleTable,
    RemoveModal,
    ViewQRModal,
    ViewAttachedFiles,
    ViewVehicleModal,
} from "./Components";

import { Modal, ModalBody, Spinner, ModalFooter, ModalHeader } from "reactstrap";

import blankProfile from "./VehicleProfile";

class VehicleList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addEditModalState: false,
            addEditModalType: "add",
            vehicleProfile: blankProfile,
            vehicleUID: false,
            page: 0,
            removeModalState: false,
            viewQRModalState: false,
            viewAttachedFileState: false,
            viewVehicleModalState: false,
            rowsPerPage: 50,
            categoryModal: false,
            newCategory: "",
            warningModal: false,
            vehicleType: ""
        };
        props.getVehicles();
        props.getDepartments();
        props.getAreas();
        props.getCategories();
        props.getTemplates();
    }

    render() {
        const { vehicles, categories, tempTitles, vehicleTypes, setFilterVehicleType, userProfile} = this.props;
        return (
            <>
                <StyledCard>
                    <StyledHeader>
                        <Typography variant="h5">Vehicle Manager</Typography>
                    </StyledHeader>

                    <br />
                    <StyledContent style={{ paddingTop: "0px" }}>
                        <Modal
                            isOpen={this.props.requesting}
                            style={{ maxWidth: "00px" }}
                        >
                            <ModalBody>
                                <div
                                    style={{
                                        textAlign: "center",
                                        paddingTop: "3em",
                                    }}
                                >
                                    <div
                                        style={{
                                            background: "white",
                                            width: "fit-content",
                                            display: "inline-block",
                                            padding: "2em",
                                        }}
                                    >
                                        <Spinner
                                            style={{
                                                height: 100,
                                                width: 100,
                                                background: "white",
                                            }}
                                            color="primary"
                                        />
                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                marginTop: 15,
                                                color: "rgba(0, 0, 0, 0.87)",
                                                fontWeight: "bolder",
                                                fontSize: 20,
                                            }}
                                            variant="subtitle1"
                                        >
                                            Processing...
                                        </Typography>
                                    </div>
                                </div>
                            </ModalBody>
                        </Modal>
                        {this.props.canCreate && (
                            <Button
                                variant="contained"
                                color="primary"
                                style={{
                                    //width: "100px",
                                    // marginTop: "30px",
                                    marginLeft: "30px",
                                    background: "#0188cc",
                                }}
                                onClick={() => {
                                    this.setState({
                                        addEditModalState: true,
                                        addEditModalType: "add",
                                        vehicleProfile: blankProfile,
                                        vehicleUID: false,
                                    });
                                }}
                            >
                                <Typography
                                    style={{
                                        color: "white",
                                    }}
                                >
                                    Add Vehicle
                                </Typography>
                            </Button>
                        )}
                        <FormControl style={{ minWidth: 200, marginLeft: 20, float:"right",marginTop:"-20px" }}>
                            <InputLabel>Filter By Categories</InputLabel>
                            <Select
                                
                                value= {this.state.vehicleType}
                                onChange= {event => {
                                    setFilterVehicleType(event.target.value)
                                    this.setState({
                                        vehicleType: event.target.value
                                    });
                                    
                                }}
                            >
                                <MenuItem value="all_categories">
                                    All Categories
                                </MenuItem>
                                {vehicleTypes &&
                                    vehicleTypes.map(e => {
                                        return (
                                            <MenuItem value={e}>{e}</MenuItem>
                                        );
                                    })}
                            </Select>
                        </FormControl>
                        {this.props.canCreate && (
                            <Button
                                variant="contained"
                                color="primary"
                                style={{
                                    // marginTop: "30px",
                                    float: "right",
                                    marginLeft: "30px",
                                    background: "#0188cc",
                                }}
                                onClick={() => {
                                    this.setState({
                                        categoryModal: true
                                    });
                                }}
                            >
                                <Typography
                                    style={{
                                        color: "white",
                                    }}
                                >
                                    ADD Category
                                </Typography>
                            </Button>
                        )}

                    </StyledContent>
                </StyledCard>
                <React.Fragment>
                    {vehicles && (
                        <VehicleTable
                            vehicles={vehicles}
                            userProfile= {userProfile}
                            setViewModal={(vehicleUID, vehicleProfile) =>
                                this.setState({
                                    viewVehicleModalState: true,
                                    vehicleUID,
                                    vehicleProfile,
                                })
                            }
                            setAddEditModal={(
                                type,
                                vehicleProfile,
                                vehicleUID
                            ) =>
                                this.setState({
                                    addEditModalState: true,
                                    addEditModalType: type,
                                    vehicleProfile,
                                    vehicleUID,
                                })
                            }
                            setRemoveModal={(vehicleUID, vehicleProfile) =>
                                this.setState({
                                    removeModalState: true,
                                    vehicleUID,
                                    vehicleProfile,
                                })
                            }
                            setViewQRModal={(vehicleUID, vehicleProfile) =>
                                this.setState({
                                    viewQRModalState: true,
                                    vehicleUID,
                                    vehicleProfile,
                                })
                            }
                            setAttachedFileModal={(
                                vehicleUID,
                                vehicleProfile
                            ) =>
                                this.setState({
                                    viewAttachedFileState: true,
                                    vehicleUID,
                                    vehicleProfile,
                                })
                            }
                            canUpdate={this.props.canUpdate}
                            canDelete={this.props.canDelete}
                        />
                    )}
                    <AddEditModal

                        templates = {this.props.templates}
                        categories = {this.props.vehicleTypes}
                        isOpen={this.state.addEditModalState}
                        setActivity={this.props.setActivity}
                        type={this.state.addEditModalType}
                        vehicle={this.state.vehicleProfile}
                        vehicleUID={this.state.vehicleUID}
                        close={() =>
                            this.setState({ addEditModalState: false })
                        }
                        setVehicle={this.props.setVehicle}
                        areas={this.props.areas}
                        departments={this.props.departments}
                        profile={this.props.profile}
                        uploadFile={this.props.uploadFile}
                        uploadMultiImages={this.props.uploadMultiImages}
                        requesting={this.props.requesting}
                    />
                    <RemoveModal
                        setActivity={this.props.setActivity}
                        isOpen={this.state.removeModalState}
                        vehicle={this.state.vehicleProfile}
                        vehicleUID={this.state.vehicleUID}
                        close={() => this.setState({ removeModalState: false })}
                        removeVehicle={this.props.removeVehicle}
                    />
                    <ViewQRModal
                        isOpen={this.state.viewQRModalState}
                        qr={this.state.vehicleProfile}
                        qrUID={this.state.vehicleUID}
                        close={() => this.setState({ viewQRModalState: false })}
                    //getQR={this.props.getQR}
                    />
                    <ViewAttachedFiles
                        isOpen={this.state.viewAttachedFileState}
                        vehicle={this.state.vehicleProfile}
                        qrUID={this.state.vehicleUID}
                        close={() =>
                            this.setState({
                                viewAttachedFileState: false,
                            })
                        }
                    />
                    <ViewVehicleModal
                        isOpen={this.state.viewVehicleModalState}
                        vehicle={this.state.vehicleProfile}
                        allInfo={vehicles}
                        close={() =>
                            this.setState({
                                viewVehicleModalState: false,
                            })
                        }
                    />

                    <Modal isOpen={this.state.categoryModal}>
                        {/* <ModalHeader>Add New User Type</ModalHeader> */}
                        <StyledHeader>
                            <Typography variant="headline">
                                Add New Category
                        </Typography>
                        </StyledHeader>
                        <StyledContent>
                            <ModalBody>
                                <TextField
                                    helperText="Category name should not include special character /" 
                                    value={this.state.newCategory}
                                    label={"Category Name"}
                                    onChange={(event) => {
                                        if (
                                            tempTitles.includes(event.target.value) === true
                                        ) {
                                            this.setState({
                                                warningModal: true,
                                            });
                                        }
                                        this.setState({
                                            newCategory: event.target.value,
                                        });
                                    }}
                                />
                               <Typography variant="h6" style={{ marginTop: 24 }}>
                                    Registered Categories
                            </Typography>
                                <List style={{ width: "100%" }}>
                                    {categories &&
                                        Object.values(categories).map(
                                            (e) => {
                                                return (
                                                    <ListItem
                                                        style={{
                                                            margin: 4,
                                                            borderLeft:
                                                                "2px solid #ddd",
                                                            width: "100%",
                                                        }}
                                                    >
                                                        {e}
                                                    </ListItem>
                                                );
                                            }
                                        )}
                                </List>
                            </ModalBody>
                        </StyledContent>
                        <ModalFooter>
                            <Button
                                onClick={() => {
                                    this.setState({
                                        categoryModal: false,
                                        newCategory : "",
                                    });
                                }}
                            >
                                Cancel
                        </Button>
                            <Button
                                disabled={this.state.newCategory === "" || this.state.newCategory.includes("/") === true}
                                onClick={() => {
                                    this.props.submitNewCategory(
                                        this.state.newCategory
                                    );
                                    this.setState({
                                        categoryModal: false,
                                        newCategory: ""
                                    });
                                }}
                                variant="contained"
                                color="primary"
                                style={{ background: this.state.newCategory.includes("/") === true ? "grey" : "#0188cc", 
                                         color: "white" 
                                       }}
                            >
                                Submit
                        </Button>
                        </ModalFooter>
                    </Modal>

                    {/* ------------------------------Warning Modal--------------------------- */}
                    <Modal isOpen={this.state.warningModal}>
                        <ModalHeader style={{ color: "red" }}>Warning!!!</ModalHeader>
                        <ModalBody>
                            <b>Category name already exists</b>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                onClick={() => {
                                    this.setState({
                                        warningModal: false,
                                        newCategory: ""
                                    });
                                }}
                            >
                                Cancel
                        </Button>
                        </ModalFooter>
                    </Modal>
                </React.Fragment>
            </>
        );
    }
}

export default connect(
    (store) => {
        return {
            vehicles: selectVehicles(store),
            requesting: getRequesting(store),
            canUpdate: canUpdate(store),
            canCreate: canCreate(store),
            canDelete: canDelete(store),
            areas: selectAreas(store),
            departments: selectDepartments(store),
            profile: selectProfile(store),
            categories: selectCategories(store),
            tempTitles: selectCategoryTitles(store),
            vehicleTypes: selectAllVehicleTypes(store),
            categoryType: selectVehicleType(store),
            templates: selectTemplates(store),
            userProfile: getUserProfile(store),
        };
    },
    {
        getVehicles,
        uploadFile,
        uploadMultiImages,
        setVehicle,
        removeVehicle,
        setActivity,
        getAreas,
        getDepartments,
        getCategories,
        submitNewCategory,
        setFilterVehicleType,
        getTemplates
    }
)(VehicleList);
